enum ReturnCodes {
  Ok = 0,

  UpsellOk = 200,
  UpsellOkWithCompensationBill = 201,

  NoSuchCustomer = -1,
  CustomerAlreadyExists = -2,
  Unauthorized = -3,

  PromoCodeDoesNotExist = -100,
  PromoCodeExpired = -102,
  PromoCodeIsAlreadyConsumed = -103,
  PromoCodePlanMismatch = -104,
  PromoCodeNotAuthorized = -105,
  PromoCodeMalformed = -106,

  InvalidCode = -200,
  InvalidTokenType = -201,
  TokenExpired = -202,

  SubscriptionPromoCodeAlreadyConsumed = -301,
  SubscriptionPromoCodeDoesNotExist = -302,

  NoSuchPlan = -401,
  NoPaymentIntentProvided = -402,
  NoSubscriptions = -403,
  MoreThan1ActiveSubscription = -404,
  NotASaaSSubscription = -405,
  CannotUpgradeToTheSamePlan = -406,
  NotTheSameCommitment = -407,
  NoBillFoundForCurrentPeriod = -408,
  UnsupportedUseCase = -409,
  PaymentFailed = -410,

  NoSuchSubscription = -500,
  SubscriptionIsNotYours = -501,
  SubscriptionIsAlreadyOver = -502,

  PDFGenerationFailed = -600,
  S3UploadFailed = -601,
  LegacyBackendFailed = -602,
  ValidationFailed = -603,

  Generic = -999
}

export default ReturnCodes;
